import React from 'react'
import PropTypes from 'prop-types'

import './contentOverlay.scss'

const ContentOverlay = ({ children }) => {
	const componentClass = 'c-content-overlay'

	return (
		<div className={componentClass}>
			<div className={`${componentClass}__inner`}>{children}</div>
		</div>
	)
}

export default ContentOverlay

ContentOverlay.propTypes = {
	children: PropTypes.node,
}

ContentOverlay.defaultProps = {
	children: null,
}
